<template>
  <div class="min-h-screen flex items-center justify-center bg-bochas-bg px-4 py-12">
    <div class="w-full max-w-md">
      <!-- Logo -->
      <div class="flex flex-col items-center mb-8">
        <img
          src="@/assets/images/logoFederacion.png"
          alt="Federación de Bochas Córdoba"
          class="w-24 h-24 mb-4 object-contain"
        />
        <h1 class="text-2xl font-bold text-white text-center">
          Configuración inicial
        </h1>
        <p class="text-gray-400 text-sm mt-2 text-center max-w-xs">
          Creá el primer usuario administrador. Está opción queda deshabilitada
          una vez creado.
        </p>
      </div>

      <!-- Card -->
      <div class="card-fbochas p-8">
        <form @submit.prevent="onSubmit" class="space-y-5">
          <!-- Nombre -->
          <div>
            <label
              for="firstname"
              class="block text-sm font-medium text-gray-300 mb-2"
            >
              Nombre
            </label>
            <input
              id="firstname"
              v-model="firstname"
              type="text"
              required
              class="w-full px-4 py-3 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo transition-colors"
              placeholder="Pablo"
            />
          </div>

          <!-- Apellido -->
          <div>
            <label
              for="lastname"
              class="block text-sm font-medium text-gray-300 mb-2"
            >
              Apellido
            </label>
            <input
              id="lastname"
              v-model="lastname"
              type="text"
              required
              class="w-full px-4 py-3 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo transition-colors"
              placeholder="Pérez"
            />
          </div>

          <!-- Email -->
          <div>
            <label
              for="email"
              class="block text-sm font-medium text-gray-300 mb-2"
            >
              Email
            </label>
            <input
              id="email"
              v-model="email"
              type="email"
              autocomplete="email"
              required
              class="w-full px-4 py-3 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo transition-colors"
              placeholder="admin@federacionbochas.com"
            />
          </div>

          <!-- Password -->
          <div>
            <label
              for="password"
              class="block text-sm font-medium text-gray-300 mb-2"
            >
              Contraseña
            </label>
            <input
              id="password"
              v-model="password"
              type="password"
              autocomplete="new-password"
              required
              minlength="6"
              class="w-full px-4 py-3 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo transition-colors"
              placeholder="Mínimo 6 caracteres"
            />
          </div>

          <!-- Confirm Password -->
          <div>
            <label
              for="confirmPassword"
              class="block text-sm font-medium text-gray-300 mb-2"
            >
              Repetir contraseña
            </label>
            <input
              id="confirmPassword"
              v-model="confirmPassword"
              type="password"
              autocomplete="new-password"
              required
              minlength="6"
              class="w-full px-4 py-3 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo transition-colors"
              placeholder="Mínimo 6 caracteres"
            />
          </div>

          <!-- Error -->
          <div
            v-if="error"
            class="bg-bochas-rojo/20 border border-bochas-rojo text-red-200 text-sm rounded-lg px-4 py-3"
          >
            {{ error }}
          </div>

          <!-- Submit -->
          <button
            type="submit"
            :disabled="loading"
            class="btn-bochas-rojo w-full flex items-center justify-center"
            :class="{ 'opacity-60 cursor-not-allowed': loading }"
          >
            <span v-if="!loading">Crear administrador</span>
            <span v-else>Creando...</span>
          </button>
        </form>
      </div>

      <!-- Volver -->
      <div class="mt-6 text-center">
        <router-link
          to="/login"
          class="text-sm text-gray-400 hover:text-white transition-colors"
        >
          ← Volver al login
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { setupAdmin } from "@/services/auth/authService";

const router = useRouter();
const firstname = ref("");
const lastname = ref("");
const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const error = ref("");
const loading = ref(false);

async function onSubmit() {
  error.value = "";

  if (password.value !== confirmPassword.value) {
    error.value = "Las contraseñas no coinciden.";
    return;
  }

  loading.value = true;
  try {
    await setupAdmin({
      firstname: firstname.value,
      lastname: lastname.value,
      email: email.value,
      password: password.value,
    });
    router.push("/admin");
  } catch (err) {
    error.value = err.message;
  } finally {
    loading.value = false;
  }
}
</script>
